var _g, _path, _path2, _rect, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAttribute = function SvgAttribute(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -8)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#6e97c4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5 15.5h19v14h-19z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.5 10.5h19v5h-19z",
    fill: "#bad9ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 13h4",
    fill: "none",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 13h7.999999",
    fill: "none",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 17.5h4",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 17.5h7.999999",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 20.5h4",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 20.5h7.999999",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 23.5h4",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 23.5h7.999999",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 26.5h4",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 26.5h7.999999",
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.5 9.5h5v21h-5z",
    fill: "#de9292",
    fillRule: "evenodd",
    stroke: "#d26464",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8 13h2",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#d26464",
    height: 10.000001,
    rx: 2.01149,
    width: 9.999999,
    x: 14.000001,
    y: 22
  })), /*#__PURE__*/React.createElement("path", {
    d: "m16.87868 29.12132 4.24264-4.24264",
    style: {
      fill: "#fcffff",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m15.000001 27h7.999999s0 0 0-2-.5-2-4-2c-3.499999 0-3.999999 0-3.999999 2z",
    fill: "#fcffff",
    fillRule: "evenodd",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "m16.87868 24.87868 4.24264 4.24264",
    style: {
      fill: "#fcffff",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAttribute, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/attribute.f496a57f.svg";
export { ForwardRef as ReactComponent };